<script setup lang="ts">
defineOptions({ name: 'AuthCode' })
import { BForm, BInput } from 'best-modules/components'
import { useSso } from '../sso'
import AuthAccount from './AuthAccount.vue'
const {
  credentials,
  codeErrorMessages,
  onCodeInput,
  mfaHint,
  verifyCode,
  openSetup,
  links,
} = useSso()
</script>
<template>
  <b-form
    class="sso-form sso-form--mfa"
    hide-action-buttons
    :submit="verifyCode">
    <auth-account></auth-account>

    <div class="sso-mfa-heading">
      <v-avatar
        class="sso-mfa-heading__icon"
        color="blue-lighten-5"
        rounded="lg"
        size="44">
        <v-icon icon="mdi-cellphone-key" size="22"></v-icon>
      </v-avatar>
      <div>
        <h2 class="sso-section-title">Підтвердження входу</h2>
        <p class="sso-section-description sso-desktop-only">
          {{ mfaHint }}
        </p>
        <p class="sso-section-description sso-mobile-only">
          Введіть 6-значний код із застосунку Microsoft Authenticator.
        </p>
      </div>
    </div>

    <div>
      <label class="sso-form__label" for="sso-code"> Код підтвердження </label>
      <b-input
        id="sso-code"
        autocomplete="one-time-code"
        class="sso-field sso-field--code"
        :error-messages="codeErrorMessages"
        inputmode="numeric"
        length="6"
        :model-value="credentials.code"
        placeholder="000000"
        @update:model-value="onCodeInput"></b-input>
      <p class="sso-form__hint">
        Код оновлюється в застосунку кожні 30 секунд.
      </p>
    </div>

    <v-btn
      block
      class="sso-submit"
      color="primary"
      :loading="
        $loading.isLoading(['confirmAuthenticator', 'verifyAuthenticator'])
      "
      type="submit">
      {{
        $loading.isLoading(['confirmAuthenticator', 'verifyAuthenticator'])
          ? 'Перевірка коду…'
          : 'Підтвердити'
      }}
    </v-btn>

    <div class="sso-form__links">
      <v-btn
        class="sso-text-button sso-desktop-only"
        color="primary"
        variant="text"
        :loading="$loading.isLoading('setupAuthenticator')"
        @click="openSetup">
        Налаштувати на новому телефоні
      </v-btn>
      <a
        v-if="links.authenticatorRecovery"
        class="sso-link"
        :href="links.authenticatorRecovery">
        Немає доступу до застосунку?
      </a>
    </div>
  </b-form>
</template>
